import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Login from "../auth/login/login";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ResetPassword3 from "../auth/resetPassword/resetPassword-3";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";
import Profile from "../pages/profile";
import LockScreen from "../auth/lockScreen";
import EmailVerification from "../auth/emailVerification/emailVerification";
import EmployeeDashboard from "../employee/employee-dashboard";
import PrivacyPolicy from "../pages/privacy-policy";
import Gallery from "../pages/gallery";
import Assets from "../asset";
import EmployeeDetails from "../hrm/employees/employeedetails";
import JobGrid from "../recruitment/jobs/jobs";
import RefferalList from "../recruitment/refferal/jobRefferalList";
import ProjectList from "../timesheet/projectlist";
import Task from "../timesheet/task";
import Tickets from "../tickets/tickets";
import TicketDetails from "../tickets/ticket-details";
import EmployeeList from "../hrm/employees/employeeDirectory";
import Holidays from "../holiday/holidays";
import TimeSheet from "../timesheet/timesheet";
import Jobdescription from "../recruitment/jobs/jobdescription";
import JobReferenceForm from "../recruitment/jobs/jobReferenceForm ";
import SupportTeam from "../recruitment/supportteam/supportteam";
import TrainingCalender from "../recruitment/trainingcalender/trainingcalender";
import AllNominations from "../recruitment/trainingcalender/nominations";
import TravelRequest from "../recruitment/travel/travelRequest";
import InsurancePage from "../recruitment/insurance/Insurance";
import GroupPersonalAccident from "../recruitment/insurance/GroupPersonalAccident";
import MyCoverage from "../recruitment/insurance/MyCoverage";
import PremiumEligibility from "../recruitment/insurance/PremiumEligibility";
import Downloadecard from "../recruitment/insurance/Downloadecard";
import HealthInsuranceCorner from "../recruitment/insurance/HealthInsuranceCorner";
import PolicyInformation from "../recruitment/insurance/PolicyInformation";
import CustomerInformationSheet from "../recruitment/insurance/CustomerInformationSheet";
import ClaimProcedures from "../recruitment/insurance/ClaimProcedures";
import Grievance from "../recruitment/insurance/grievance";
import Sops from "../recruitment/Sops/Sops";
import Elibrary from "../recruitment/Elibrary/Elibrary";
import Wetalk from "../recruitment/wetalk/wetalk";
import GalleryDetail from "../pages/gallery/GalleryDetail";
import OrganisationStructure from "../hrm/employees/organisationstructure";
import LeaveApplication from "../leave/selfLeave/leaveApplication";
import LeaveDetailCoordinator from "../leave/selfLeave/leaveDetail";
import LeaveBalanceCoordinator from "../leave/selfLeave/leaveBalance";
import LeaveTeamMemberCoordinator from "../leave/teamleave/leaveTeamMember";
import LeaveApplicationTeam from "../leave/teamleave/leaveApplication";
import LeaveDetailTeamMember from "../leave/teamleave/leaveDetailTeamMember";
import TeamLeaveBalance from "../leave/teamleave/teamLeaveBalance";
import TeamattendenceCalender from "../leave/teamleave/teamLeaveCalender";
import LeaveClender from "../leave/selfLeave/leaveClender";
import TeamOutdutyDetails from "../outduty/teamoutduty/teamOutdutyDetails";
import Recognition from "../recognition/recognition";
import Organisation from "../orgnazation/organization";
import WhoweAre from "../orgnazation/whoweAre";
import Cultureandpeople from "../orgnazation/cultureandpeople";
import OurValue from "../orgnazation/ourValue";
import Ourmission from "../orgnazation/ourmission";
import InternalServerError from "../pages/error/error500";
import EditExpenserequest from "../recruitment/travel/editExpenserequest";
import EditLeaveApplication from "../leave/selfLeave/editleaveApplication";
import EngagementCalender from "../engagementCalender/engagementCalender";
import NoticeCircular from "../recruitment/candidates/noticecirculars";
import DigitalAssests from "../uiInterface/base-ui/digitalAssests/digitalAssests";
import Expense from "../recruitment/travel/expense";
import OutdutyTeamStatus from "../outduty/teamoutduty/outdutyTeamStatus";
import OutdutyTeamMember from "../outduty/teamoutduty/outdutyTeamMember";
import OutdutyApplicationTeamMamber from "../outduty/teamoutduty/outdutyApplicationTeamMamber";
import Communication from "../settings/profileUpdate/communication";
import PersonalInfo from "../settings/profileUpdate/personalInfo";
import FamilyDetails from "../settings/profileUpdate/familyDetails";
import Langauge from "../settings/profileUpdate/langauge";
import PreviousWork from "../settings/profileUpdate/previousWork";
import Educations from "../settings/profileUpdate/educations";
import Miscellaneous from "../settings/profileUpdate/miscellaneous";
import NomineePF from "../settings/profileUpdate/nomineePF";
import NominationsGratutity from "../settings/profileUpdate/nominationsGratutity";
import Compensation from "../settings/profileUpdate/compensation";
import TeamleaveStatus from "../leave/teamleave/teamleaveStatus";
import OutdutyDetails from "../outduty/selfoutduty/outdutyDetails";
import OutdutyApplication from "../outduty/selfoutduty/outdutyApplication";
import OutdutyEditApplication from "../outduty/selfoutduty/outdutyEditApplication";
import ODReport from "../outduty/teamoutduty/odReport";
import LeaveReport from "../leave/teamleave/leaveReport";
import OutdutyCalender from "../outduty/selfoutduty/outdutyCalender";
import SubmitDetails from "../settings/profileUpdate/submit";
import DefineKRA from "../pms/kra/WeightageKra";
import EmployeeKraReview from "../pms/kra/employeeReview";
import View_Behavioural from "../pms/behavioural/view_behavioural";
import EmployeeBehaviouralReview from "../pms/behavioural/employeeReview";
import Kra_Goals from "../pms/kra/kra_goals";
import DefineBehaviouralCompetency from "../pms/behavioural/defineBehaviouralCompetency";
import PMSCategory from "../pms/pmscategory";
import KRAs from "../pms/kra/kras";
import Goals from "../pms/goals";
import SelfLeaveGrid from "../leave/selfLeave/selfLeaveGrid";
import TeamLeaveGrid from "../leave/teamleave/teamLeaveGrid";
import SelfOutDutyGrid from "../outduty/selfoutduty/selfOutDutyGrid";
import TeamOutDutyGrid from "../outduty/teamoutduty/teamOutDutyGrid";
import PMSGrid from "../performance/pmsGrid";
import FunChart from "../hrm/employees/functional/FunChart";
import OrgChart from "../hrm/employees/organization_stracture/OrgChart";
import GoalSummary from "../pms/goalProfileSelf/goalSummary";
import KraProfile from "../pms/goalProfileSelf/kraProfile";
import GoalsProfile from "../pms/goalProfileSelf/goalsProfile";
import GoalsProfileUpdate from "../pms/goalProfileSelf/goalsProfileUpdate";
import SelfBehaviouralCompetency from "../pms/goalProfileSelf/SelfBehaviouralCompetency";
import AllEmployeeGoalsProfile from "../pms/teamGoals/allEmployeeGoals";
import PerformanceReview from "../pms/goalProfileSelf/performanceReview";
import EmployeeGoalSummary from "../pms/teamGoals/employeegoalSummary";
import EmployeePerformanceReview from "../pms/teamGoals/employeeperformanceReview";
import CareerAspirations from "../pms/goalProfileSelf/careerAspirations";
import SelfLeaveDashboard from "../leave/selfLeave/dashboard";
import TeamLeaveDashboard from "../leave/teamleave/teamLeaveDashboard";
import SelfOutDutyDashboard from "../outduty/selfoutduty/selfOutDutyDashboard";
import OutdutyTeamCalendar2 from "../outduty/teamoutduty/outdutyTeamCalendar";
import EmployeeTraningList from "../trainer/EmployeeCalendar";
import NominationPage from "../trainer/NominationPage";
import SURVEYPOLLS from "../recruitment/surveypolls/SurveyPolls";
import EmployeePMS from "../performance/PmsEmployee/employeePMS";
import AllEmployeesR1Manager from "../performance/R1Manager/r1AllEmployee";
import PmsReviewManager from "../performance/R1Manager/pmsR1Manager";
import PmsR2Manager from "../performance/R2Manager/pmsR2Manager";
import AllEmployeesHod from "../performance/Hod/hodAllEmployee";
import PmsReviewHod from "../performance/Hod/PmsReviewHod";
import AttendanceDashboard from "../attendance/attendanceDashboard";
import AttendanceTeamDashboard from "../attendance/attendanceTeamDashboard";
import MarkMyAttendance from "../attendance/selfAttendance/markMyAttendance";
import MyattendanceRegularization from "../attendance/selfAttendance/myattendanceRegularization";
import MyattendanceHistory from "../attendance/selfAttendance/myattendanceHistory";
import MyAttendance from "../attendance/selfAttendance/myAttendance";
import RegularizationTeam from "../attendance/teamAttendance/regularizationTeam";
import TeamattendanceHistory from "../attendance/teamAttendance/teamattendanceHistory";
import AttendanceTeam from "../attendance/teamAttendance/attendanceTeam";
import EmployeeView from "../trainer/EmployeeView";
import Manager from "../trainer/Manager";
import Assessment from "../trainer/Assessment";
import SelfHelp from "../selfhelp/selfHelp";
import TimeSheetLog from "../timesheet/timesheetLog";
import TimeSheetLogEmployees from "../timesheet/timesheetLogEmployees";
import ChangePassword from "../auth/login/chnagePassword";
import NoInternet from "../pages/error/NoInternet";
import TimeoutPage from "../pages/error/TimeoutPage";
import UserGuide from "../pms/userGuide";
import OrgProfile from "../pages/profile/orgProfile";
import R1ManagerAllEmployee from "../performance/R2Manager/r1ManagerAllEmployee";
import CompensationPage from "../compensation/compensation";
import AnnexurePage from "../compensation/annexure";
import Payslip from "../employee/payslip";
import SelfResignationGrid from "../resgination/selfResignationGrid";
import ExitInterviewPage from "../resgination/exitform/temp";
import TeamResignationGrid from "../resgination/teamResignationGrid";
import ResginationApplication from "../resgination/resginationApplication";
import ViewResignation from "../resgination/viewResignationFrom";
import Addresignation from "../resgination/addresginationFrom";
import ResginationApproval from "../resgination/resignationApproval";
import ClearanceForm from "../resgination/clearanceForm";
import ManagerViewResignation from "../resgination/managerviewPage";
import ClearanceView from "../resgination/clearanceView";
import AddProjectPage from "../timesheet/timesheet-pages/addProject";
import EditProject from "../timesheet/timesheet-pages/editProject";
import AddTask from "../timesheet/timesheet-pages/addTask";
import EditTask from "../timesheet/timesheet-pages/editTask";
import TimeSheetsLog from "../timesheet/timesheet-pages/time-logs";
import TimeLogDetails from "../timesheet/timesheet-pages/timeLogDetails";
import Announcements from "../recruitment/candidates/announcements";
import EmployeeSpeak from "../recruitment/candidates/employeeSpeak";
import RecruitmentDashBoard from "../recruitment-module/recruitmentDashboard";
// import MprForm from "../recruitment-module/requisition-form copy 2";
// import PreviewResume from "../recruitment-module/resume-preview copy";
import ViewApplicationRequisition from "../recruitment-module/view-application";
import RequisitionApprovalForm from "../recruitment-module/requistion-approval";
import DataBank from "../recruitment-module/dataBank";
import ViewMprForm from "../recruitment-module/view-requisition-form";
import MprForm from "../recruitment-module/requisition-form";
import PreviewResume from "../recruitment-module/resume-preview";
import ViewPaySlip from "../emp-pay-slip/ViewPaySlipDetails";
import EnabledProbationList from "../employee-assessment-forms/EnabledProbationList";
import EnabledMonthlyList from "../employee-assessment-forms/EnabledMonthlyList";
import AssessmentFormsList from "../employee-assessment-forms/AssessmentFormsList";
import BuddyFeedbackForm from "../all-forms/BuddyFeedbackForm";
import ProbationAssessmentForm from "../all-forms/ProbationAssessmentForm";
import MonthlyOnboardingFeedbackForm from "../all-forms/MonthlyOnboardingFeedbackForm";
import InterviewAssessmentForm from "../all-forms/InterviewAssessmentForm";
import InductionFeedbackForm from "../all-forms/InductionFeedbackForm";
import AppraisalLetter from "../pms/AppraisalLetter";
import Selffeedback from "../feedback/Selffeedback";
import FeedbackTeamMembers from "../feedback/FeedbackTeamMembers";
import MonthlyFeedbackForm from "../feedback/MonthlyFeedbackForm";
// import MyAttendance from "../attendance/selfAttendance/myAttendance";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <EmployeeDashboard />,
    route: Route,
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />,
    route: Route,
  },
  {
    path: routes.allnominations,
    element: <AllNominations />,
  },
  {
    path: routes.travell,
    element: <Expense />,
  },
  {
    path: routes.travelrequest,
    element: <TravelRequest />,
  },
  {
    path: routes.edittravelrequest,
    element: <EditExpenserequest />,
  },
  {
    path: routes.insurance,
    element: <InsurancePage />,
  },
  {
    path: routes.groupPersonalAccident,
    element: <GroupPersonalAccident />,
  },
  {
    path: routes.mycoverage,
    element: <MyCoverage />,
  },
  {
    path: routes.premiumeligibility,
    element: <PremiumEligibility />,
  },
  {
    path: routes.downloadecard,
    element: <Downloadecard />,
  },
  {
    path: routes.healthInsuranceCorner,
    element: <HealthInsuranceCorner />,
  },
  {
    path: routes.policyInformation,
    element: <PolicyInformation />,
  },
  {
    path: routes.customerInformationSheet,
    element: <CustomerInformationSheet />,
  },
  {
    path: routes.claimprocedures,
    element: <ClaimProcedures />,
  },
  {
    path: routes.grievance,
    element: <Grievance />,
  },
  {
    path: routes.sops,
    element: <Sops />,
  },
  {
    path: routes.surveypolls,
    element: <SURVEYPOLLS />,
  },
  {
    path: routes.elibrary,
    element: <Elibrary />,
  },
  {
    path: routes.compensationPage,
    element: <CompensationPage />,
  },
  {
    path: routes.annexurePage,
    element: <AnnexurePage />,
  },

  //Attendance
  {
    path: routes.attendanceGrid,
    element: <AttendanceDashboard />,
  },
  {
    path: routes.attendanceTeamDashboard,
    element: <AttendanceTeamDashboard />,
  },
  {
    path: routes.selfattendance,
    element: <MyAttendance />,
  },
  {
    path: routes.selfattendancehis,
    element: <MyattendanceHistory />,
  },
  {
    path: routes.markmyattendance,
    element: <MarkMyAttendance />,
  },
  {
    path: routes.myattendanceRegularization,
    element: <MyattendanceRegularization />,
  },
  {
    path: routes.RegularizationTeam,
    element: <RegularizationTeam />,
  },
  {
    path: routes.teamattendancehis,
    element: <TeamattendanceHistory />,
  },
  {
    path: routes.ViewattendanceTeam,
    element: <AttendanceTeam />,
  },
  // Leave
  {
    path: routes.seflGrid,
    element: <SelfLeaveGrid />,
  },

  {
    path: routes.selfLeaveApply,
    element: <LeaveApplication />,
  },
  {
    path: routes.selfLeaveDashboard,
    element: <SelfLeaveDashboard />,
  },
  {
    path: routes.editLeaveApplication,
    element: <EditLeaveApplication />,
  },
  {
    path: routes.selfLeaveDetails,
    element: <LeaveDetailCoordinator />,
  },

  {
    path: routes.selfleaveBalance,
    element: <LeaveBalanceCoordinator />,
  },

  {
    path: routes.teamleaveStatus,
    element: <TeamleaveStatus />,
  },

  {
    path: routes.leaveReport,
    element: <LeaveReport />,
  },
  {
    path: routes.teamMemberleave,
    element: <LeaveTeamMemberCoordinator />,
  },
  {
    path: routes.teamLeaveDashboard,
    element: <TeamLeaveDashboard />,
  },
  {
    path: routes.teamleaveTeamMember,
    element: <LeaveApplicationTeam />,
  },
  {
    path: routes.teamleaveDetailsTeamMember,
    element: <LeaveDetailTeamMember />,
  },

  // live
  {
    path: routes.teamGrid,
    element: <TeamLeaveGrid />,
  },
  {
    path: routes.teamleaveBalanceTeamMember,
    element: <TeamLeaveBalance />,
  },
  {
    path: routes.teamleaveCalender,
    element: <TeamattendenceCalender />,
  },
  {
    path: routes.selfleaveCalender,
    element: <LeaveClender />,
  },
  // OutDuty
  {
    path: routes.selfOutDutyGrid,
    element: <SelfOutDutyGrid />,
  },
  {
    path: routes.outdutyApplication,
    element: <OutdutyApplication />,
  },
  {
    path: routes.editoutdutyApplication,
    element: <OutdutyEditApplication />,
  },
  {
    path: routes.teamOutDutyGrid,
    element: <TeamOutDutyGrid />,
  },
  {
    path: routes.outdutyDetailsTeamMember,
    element: <TeamOutdutyDetails />,
  },
  {
    path: routes.selfOutDutyDashboard,
    element: <SelfOutDutyDashboard />,
  },
  {
    path: routes.applyoutdutyTeamMember,
    element: <OutdutyApplicationTeamMamber />,
  },
  {
    path: routes.outdutyReport,
    element: <ODReport />,
  },
  {
    path: routes.outdutyDetails,
    element: <OutdutyDetails />,
  },

  {
    path: routes.outdutyTeamStatus,
    element: <OutdutyTeamStatus />,
  },
  {
    path: routes.outdutyCalenderTeamMember,
    element: <OutdutyTeamCalendar2 />,
  },
  {
    path: routes.outdutyTeamMember,
    element: <OutdutyTeamMember />,
  },

  {
    path: routes.outdutyCalender,
    element: <OutdutyCalender />,
  },

  // Attandence

  // Trainer
  {
    path: routes.employeeTraningList,
    element: <EmployeeTraningList />,
  },
  {
    path: routes.nominationPage,
    element: <NominationPage />,
  },
  {
    path: routes.employeeView,
    element: <EmployeeView />,
  },
  {
    path: routes.assessment,
    element: <Assessment />,
  },
  {
    path: routes.manager,
    element: <Manager />,
  },

  //Application
  {
    path: routes.digitalassets,
    element: <DigitalAssests />,
    route: Route,
  },
  {
    path: routes.tickets,
    element: <Tickets />,
    route: Route,
  },
  {
    path: routes.ticketDetails,
    element: <TicketDetails />,
    route: Route,
  },
  {
    path: routes.holidays,
    element: <Holidays />,
    route: Route,
  },
  {
    path: routes.pmsGrid,
    element: <PMSGrid />,
    route: Route,
  },
  {
    path: routes.pmsReview,
    element: <EmployeePMS />,
    route: Route,
  },
  {
    path: routes.pmsAllEmployeeR1,
    element: <AllEmployeesR1Manager />,
    route: Route,
  },
  {
    path: routes.pmsReviewManager,
    element: <PmsReviewManager />,
    route: Route,
  },
  {
    path: routes.pmsAllEmployeeR2,
    element: <R1ManagerAllEmployee />,
    route: Route,
  },
  {
    path: routes.Payslip,
    element: <Payslip />,
    route: Route,
  },
  {
    path: routes.pmsReviewManagerR2,
    element: <PmsR2Manager />,
    route: Route,
  },
  {
    path: routes.pmsAllEmployeeHod,
    element: <AllEmployeesHod />,
    route: Route,
  },
  {
    path: routes.pmsReviewHod,
    element: <PmsReviewHod />,
    route: Route,
  },

  {
    path: routes.selfmonthlyfeedback,
    element: <Selffeedback />,
    route: Route,
  },
  {
    path: routes.teammonthlyfeedback,
    element: <FeedbackTeamMembers />,
    route: Route,
  },

  {
    path: routes.monthlyfeedback,
    element: <MonthlyFeedbackForm />,
    route: Route,
  },

  //Settings
  {
    path: routes.communication,
    element: <Communication />,
  },
  {
    path: routes.personal,
    element: <PersonalInfo />,
  },
  {
    path: routes.familyDependentDetails,
    element: <FamilyDetails />,
  },
  {
    path: routes.languageProficiency,
    element: <Langauge />,
  },
  {
    path: routes.previousWork,
    element: <PreviousWork />,
  },
  {
    path: routes.nominationsPf,
    element: <NomineePF />,
  },
  {
    path: routes.nominationsGratuity,
    element: <NominationsGratutity />,
  },
  {
    path: routes.mycompession,
    element: <Compensation />,
  },
  {
    path: routes.education,
    element: <Educations />,
  },
  {
    path: routes.miscellaneous,
    element: <Miscellaneous />,
  },
  {
    path: routes.prevsubmit,
    element: <SubmitDetails />,
  },
  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.orgProfile,
    element: <OrgProfile />,
  },
  {
    path: routes.gallery,
    element: <Gallery />,
  },
  {
    path: routes.gallerydetails,
    element: <GalleryDetail />,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: routes.assetList,
    element: <Assets />,
  },
  {
    path: routes.employeedetails,
    element: <EmployeeDetails />,
    route: Route,
  },
  {
    path: routes.employeedetailsWithId,
    element: <EmployeeDetails />,
    route: Route,
  },
  {
    path: routes.jobgrid,
    element: <JobGrid />,
    route: Route,
  },
  {
    path: routes.jobdescription,
    element: <Jobdescription />,
    route: Route,
  },
  {
    path: routes.recognition,
    element: <Recognition />,
    route: Route,
  },
  {
    path: routes.jobrefrence,
    element: <JobReferenceForm />,
    route: Route,
  },
  {
    path: routes.supportteam,
    element: <SupportTeam />,
    route: Route,
  },
  {
    path: routes.wetalk,
    element: <Wetalk />,
    route: Route,
  },
  {
    path: routes.trainingcalnder,
    element: <TrainingCalender />,
    route: Route,
  },
  {
    path: routes.noticecirculars,
    element: <NoticeCircular />,
    route: Route,
  },
  {
    path: routes.announcements,
    element: <Announcements />,
    route: Route,
  },
  {
    path: routes.employeeSpeak,
    element: <EmployeeSpeak />,
    route: Route,
  },
  {
    path: routes.refferal,
    element: <RefferalList />,
    route: Route,
  },
  {
    path: routes.projectlist,
    element: <ProjectList />,
    route: Route,
  },
  {
    path: routes.tasks,
    element: <Task />,
    route: Route,
  },
  {
    path: routes.engagementcalendar,
    element: <EngagementCalender />,
    route: Route,
  },
  {
    path: routes.employeedirectory,
    element: <EmployeeList />,
    route: Route,
  },
  {
    path: routes.organisationstructure,
    element: <OrganisationStructure />,
    route: Route,
  },
  {
    path: routes.orgStructure,
    element: <OrgChart />,
    route: Route,
  },
  {
    path: routes.funStructure,
    element: <FunChart />,
    route: Route,
  },
  {
    path: routes.organisation,
    element: <Organisation />,
    route: Route,
  },
  {
    path: routes.whoarewe,
    element: <WhoweAre />,
    route: Route,
  },
  {
    path: routes.cultureandpeople,
    element: <Cultureandpeople />,
    route: Route,
  },
  {
    path: routes.overValue,
    element: <OurValue />,
    route: Route,
  },
  {
    path: routes.ourmission,
    element: <Ourmission />,
    route: Route,
  },
  {
    path: routes.selfhelp,
    element: <SelfHelp />,
    route: Route,
  },

  {
    path: routes.timesheet,
    element: <TimeSheet />,
    route: Route,
  },
  {
    path: routes.timesheetlog,
    element: <TimeSheetLog />,
    route: Route,
  },
  {
    path: routes.timesheetlogemployee,
    element: <TimeSheetLogEmployees />,
    route: Route,
  },
  // pms
  {
    path: routes.pmscategory,
    element: <PMSCategory />,
    route: Route,
  },
  {
    path: routes.pmsKra,
    element: <KRAs />,
    route: Route,
  },
  {
    path: routes.weightageKra,
    element: <DefineKRA />,
    route: Route,
  },
  {
    path: routes.kraGoals,
    element: <Kra_Goals />,
    route: Route,
  },
  {
    path: routes.employeePmsReview,
    element: <EmployeeKraReview />,
    route: Route,
  },
  {
    path: routes.viewBehavioural,
    element: <View_Behavioural />,
    route: Route,
  },
  {
    path: routes.goals,
    element: <Goals />,
    route: Route,
  },
  {
    path: routes.defineBehaviouralCompetency,
    element: <DefineBehaviouralCompetency />,
    route: Route,
  },
  {
    path: routes.behaviouralEmployeeReview,
    element: <EmployeeBehaviouralReview />,
    route: Route,
  },
  {
    path: routes.performanceReview,
    element: <PerformanceReview />,
    route: Route,
  },
  {
    path: routes.goalsSummary,
    element: <GoalSummary />,
    route: Route,
  },
  {
    path: routes.pmsCareerAspirations,
    element: <CareerAspirations />,
    route: Route,
  },
  {
    path: routes.kraProfile,
    element: <KraProfile />,
    route: Route,
  },
  {
    path: routes.allEmployeeGoals,
    element: <AllEmployeeGoalsProfile />,
    route: Route,
  },
  {
    path: routes.employeeperformanceReview,
    element: <EmployeePerformanceReview />,
    route: Route,
  },
  {
    path: routes.employeegoalsSummary,
    element: <EmployeeGoalSummary />,
    route: Route,
  },
  {
    path: routes.goalsProfile,
    element: <GoalsProfile />,
    route: Route,
  },
  {
    path: routes.goalsProfileupdate,
    element: <GoalsProfileUpdate />,
    route: Route,
  },
  {
    path: routes.userguide,
    element: <UserGuide />,
    route: Route,
  },
  {
    path: routes.appraisalLetter,
    element: <AppraisalLetter />,
    route: Route,
  },
  {
    path: routes.behaviouralCompetency,
    element: <SelfBehaviouralCompetency />,
    route: Route,
  },

  {
    path: routes.employeePayslip,
    element: <ViewPaySlip />,
  },

  // ================================================================================================

  // Resignation Page
  {
    path: routes.selfOffboarding,
    element: <SelfResignationGrid />,
  },
  //Exit form
  {
    path: routes.exitoffboardingpage,
    element: <ExitInterviewPage />,
  },
  // Team resignation
  {
    path: routes.teamoffboarding,
    element: <TeamResignationGrid />,
  },
  {
    path: routes.exitoffboardingpage,
    element: <TeamResignationGrid />,
  },
  {
    path: routes.resignationList,
    element: <ResginationApplication />,
  },
  {
    path: routes.resignationView,
    element: <ViewResignation />,
  },
  // {
  //   path: routes.resignationViewEmployee,
  //   element: <ViewResignation />
  // },
  {
    path: routes.managerView,
    element: <ManagerViewResignation />,
  },
  {
    path: routes.offboardingForm,
    element: <Addresignation />,
  },
  //manager view only resignation
  {
    path: routes.resigantionApproval,
    element: <ResginationApproval />,
  },
  {
    path: routes.resigantionClearance,
    element: <ClearanceForm />,
  },
  {
    path: routes.teamClearance,
    element: <ClearanceView />,
  },

  // Time Logs

  // TIME-SHEET
  {
    path: routes.addProject,
    element: <AddProjectPage />,
    route: Route,
  },
  {
    path: routes.editProject,
    element: <EditProject />,
    route: Route,
  },
  {
    path: routes.addTasks,
    element: <AddTask />,
    route: Route,
  },
  {
    path: routes.editTasks,
    element: <EditTask />,
    route: Route,
  },
  {
    path: routes.timeLogs,
    element: <TimeSheetsLog />,
    route: Route,
  },
  {
    path: routes.timeLogsDetails,
    element: <TimeLogDetails />,
    route: Route,
  },

  // Recruitment
  {
    path: routes.RecruitmentDashboard,
    element: <RecruitmentDashBoard />,
  },
  {
    path: routes.MRP_FORM,
    element: <MprForm />,
  },
  {
    path: routes.resumePreview,
    element: <PreviewResume />,
  },
  {
    path: routes.ViewRecuritment,
    element: <ViewApplicationRequisition />,
  },
  {
    path: routes.ApprovalRequisition,
    element: <RequisitionApprovalForm />,
  },
  {
    path: routes.DataBank,
    element: <DataBank />,
  },
  // {
  //   path: routes.SelectInterviwer,
  //   element: <SelectInterviewer />
  // },
  {
    path: routes.ViewRequitionForm,
    element: <ViewMprForm />,
  },

  // ---- bhawna forms ----
  {
    path: routes.managerEnabledProbationAssessment,
    element: <EnabledProbationList />,
    route: Route,
  },
  {
    path: routes.managerEnabledMonthlyAssessment,
    element: <EnabledMonthlyList />,
    route: Route,
  },
  {
    path: `${routes.buddyFeedbackForm}`,
    element: <BuddyFeedbackForm />,
    route: Route,
  },
  {
    path: `${routes.probationAssessmentFormByID}/:emp_id`,
    element: <ProbationAssessmentForm />,
    route: Route,
  },
  {
    path: `${routes.probationAssessmentForm}/:id/:assessment_id`,
    element: <ProbationAssessmentForm />,
    route: Route,
  },
  {
    path: `${routes.monthlyFeedbackFormByID}/:id/:employee_id`,
    element: <MonthlyOnboardingFeedbackForm />,
    route: Route,
  },
  // {
  //   path: `${routes.monthlyOnboardingFeedbackForm}/:id/:onboarding_id`,
  //   element: <MonthlyOnboardingFeedbackForm />,
  //   route: Route,
  // },
  {
    path: `${routes.interviewAssessmentForm}/:id`,
    element: <InterviewAssessmentForm />,
    route: Route,
  },

  // -- independent induction form
  {
    path: routes.inductionFeedbackForm,
    element: <InductionFeedbackForm />,
    route: Route,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.resetPassword3,
    element: <ResetPassword3 />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.internalserverError,
    element: <InternalServerError />,
    route: Route,
  },
  {
    path: routes.NoInternet,
    element: <NoInternet />,
    route: Route,
  },
  {
    path: routes.TimeoutPage,
    element: <TimeoutPage />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
  },
  {
    path: routes.ChangePassword,
    element: <ChangePassword />,
    route: Route,
  },
];
